export default __webpack_public_path__ + "fba4c1d9c585d151ca370b514041ce38.svg";